module.exports = __webpack_public_path__ + "static/media/Http404.e9b539e9.svg";